export const USER_SET_USER_TOKEN = "USER_SET_USER_TOKEN";
export const USER_SET_USER_INFO = "USER_SET_USER_INFO";
export const USER_RESET_USER = "USER_RESET_USER";
export const USER_CONNECT_WALLET = "USER_CONNECT_WALLET";
export const USER_DISCONNECT_WALLET = "USER_DISCONNECT_WALLET";